(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5056],{

/***/ 91335:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent-engine/interviews",
      function () {
        return __webpack_require__(47287);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ interviews; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/marketingSite/talentEngineV3/sections/footer/TalentEngineFooter.tsx + 7 modules
var TalentEngineFooter = __webpack_require__(65602);
// EXTERNAL MODULE: ./components/marketingSite/talentEngineV3/pages/TalentEnginePage.styled.tsx
var TalentEnginePage_styled = __webpack_require__(79748);
// EXTERNAL MODULE: ./components/marketingSite/talentEngineV3/sections/nav/Nav.tsx + 3 modules
var Nav = __webpack_require__(463);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ./components/marketingSite/talentEngineV3/pages/TalentEnginePage.constants.tsx
var TalentEnginePage_constants = __webpack_require__(32516);
// EXTERNAL MODULE: ./components/marketingSite/talentEngineV3/pages/feature/Feature.tsx + 1 modules
var Feature = __webpack_require__(60877);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./components/marketingSite/talentEngineV3/pages/TalentEngineInterviews.tsx















var TalentEngineInterviews = function() {
    var t = (0,useI18n/* useI18n */.Q)("talent-engine-interviews").t;
    var features = (0,TalentEnginePage_constants/* INTERVIEWSPAGEFEATURES */.MH)(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        pageVariant: "light",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentEnginePage_styled/* StyledPage */.Ft, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentEnginePage_styled/* StyledWrapper */.SD, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentEnginePage_styled/* StyledHeader */.eb, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                                        children: t("talent-engine-interviews.hero.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                        ns: "talent-engine-interviews",
                                        i18nKey: t("talent-engine-interviews.hero.desc")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                        to: "talentEngineForm",
                                        href: "#talentEngineForm",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                                            as: "div",
                                            onClick: function() {
                                                return service_event_tracking/* default.trackLandingCtaClicked */.Z.trackLandingCtaClicked("talent-engine-quiero-sublanding-consigue-entrevistas");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("talent-engine-interviews.hero.cta")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentEnginePage_styled/* StyledFeatureList */.tm, {
                                children: features.map(function(feature, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature/* default */.Z, {
                                        title: feature.title,
                                        image: feature.image,
                                        desc: feature.desc
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentEngineFooter/* default */.Z, {
                        isLight: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_TalentEngineInterviews = (TalentEngineInterviews);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./pages/talent-engine/interviews/index.tsx







var TalentEngineInterviewsPage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("talent-engine-interviews").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("talent-engine-interviews.page_title"),
                url: app_urls/* APP_URLS.talentEngineInterviews */.uu.talentEngineInterviews,
                desc: t("talent-engine-interviews.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_talent_engine.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_TalentEngineInterviews, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var interviews = (TalentEngineInterviewsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,3955,1534,625,4882,2987,6248,2590,235,9774,2888,179], function() { return __webpack_exec__(91335); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);